import { useTranslation } from "react-i18next";
import { DateFormatType, formatDate } from "~/common/utils/DateFormatter";
import { showDateAsCalendarWeek } from "~/utils/features";

export interface StockEntry {
  quantity: number;
  date: string;
  sale?: true;
  soldOut?: true;
}

/**
 * Common entry type from API for both inStock and inProduction
 */
interface RawEntry {
  quantity: number;
  date?: string | Date;
  cwDate?: string;
  sale?: true;
  soldOut?: true;
}

export const useAvailabilityEntries = () => {
  const { t } = useTranslation();

  const transform = (entries: RawEntry[], weeklyEntries: RawEntry[]): StockEntry[] => {
    if (showDateAsCalendarWeek()) {
      return weeklyEntries.map((entry) => ({
        quantity: entry.quantity,
        date: entry.cwDate || t("productDetailsPage.availabilityTable.readyForShipment", { quantity: "" }),
        sale: entry.sale,
        soldOut: entry.soldOut,
      }));
    }

    return entries.map((entry) => ({
      quantity: entry.quantity,
      date: entry.date
        ? formatDate(new Date(entry.date), DateFormatType.DATE)
        : t("productDetailsPage.availabilityTable.readyForShipment", { quantity: "" }),
      sale: entry.sale,
      soldOut: entry.soldOut,
    }));
  };

  return { transform };
};
